import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Details from "../../components/DetailsComponent";
import ReusableImageGallery from "../../components/ReusableImageGallery";

export default function CampRetrospective() {
  const intro1 = "Anul acesta, unul dintre cele mai de suflet proiecte ale noastre a prins viata, transformand dorinta de a oferi sprijin intr-o experienta concreta pentru 12 copii cu tulburare de spectru autist si familiile lor.";

  const intro2 = "Am ajuns la mare… Am gandit si ne-am dorit contexte de grup in care sa exersam abilitatile de comunicare si relationare antrenate atat de mult in cabinet. Ne-am dorit un mediu multisenzorial care sa ne ofere cat mai multe cadre in care sa exersam desensibilizarea senzoriala. Ne-am dorit un mediu nou, in care sa putem dezvolta capacitatea de adaptare la schimbare si cresterea tolerantei la frustrare. Ne-am dorit un timp si spatiu in care parintii sa poata exprima ce progrese observa si ce provocari intampina. Ne-am mai dorit si un loc care, in final, sa ofere bucurie. Si am ajuns impreuna, cu bine, la mare. Cu copii, mamici si bunici care au vazut acum pentru prima data marea.";

  const mainFocus = "Accentul principal in aceste zile a fost pus pe crearea unui mediu sigur, in care fiecare copil sa poata explora lumea in propriul ritm. Activitatile au fost concepute pentru a transforma dificultatile in oportunitati de invatare:";

  const sensoryDesc = "Departe de peretii cabinetului, am organizat sesiuni personalizate in care copiii au interactionat cu texturi, sunete si stimuli noi. Fie ca a fost vorba despre hipo sau hipersensibilitate, interventiile au vizat imbunatatirea raspunsului senzorial, pregatindu-i pe cei mici pentru o mai buna adaptare in spatii publice diverse.";

  const generalizationDesc = "Programul prestabilit de sedinte individuale le-a permis terapeutilor sa lucreze la transferul cunostintelor teoretice in contexte reale. Intr-un cadru natural, copiii au exersat abilitati de autonomie si comunicare, demonstrand ca pot aplica ceea ce au invatat si in afara rutinei stricte de acasa.";

  const socializationDesc = "Terapia de grup a fost, poate, cel mai dinamic moment al zilei. Prin jocuri interactive atent structurate, copiii au fost incurajati sa comunice unii cu ceilalti, sa exerseze relationarea si sa isi dezvolte abilitatile sociale.";

  const parentSection1 = "In timp ce copiii explorau noi frontiere ale dezvoltarii lor, parintii au beneficiat de un spatiu dedicat lor, spatiu in care vulnerabilitatea s-a transformat in putere. Grupurile de sprijin pentru parinti au urmarit dezvoltarea de abilitati co-terapeutice, cresterea sentimentului de autoeficacitate si control al parintilor, sprijinirea lor in ceea ce priveste controlul stresului, crearea unor supape de descarcare, valorificarea propriei persoane, insusirea celorlalte roluri - de partener si persoana activa in societate, adaptarea la nevoile copilului si acceptarea diferentelor propriului copil.";

  const parentSection2 = "Experienta comuna a parintilor permite auto-dezvaluirea, acceptarea, normalizarea, instalarea sperantei, experiente de tip catharsis si insight-uri. Intr-un cadru sigur, unde celelalte inteleg prin ce trec, mamele au discutat despre dificultati, frustrari, sentimente de neputinta si temerile legate de viitorul propriului copil.";

  const psyQuote = "Pe parcursul zilelor petrecute impreuna mamele se bucura de un timp pretios, dedicat ingrijirii de sine, reconectarii cu propriile nevoi si resurse interioare. Toate acestea se intampla intr-un cadru prietenos si relaxant, in care dorim ca ele sa constientizeze importanta propriei stari de bine si crearea unor amintiri pozitive, prin activitati comune, care sa le ofere energie si inspiratie pentru perioada urmatoare.";

  const psyAttribution = "- psih. Elena Patrut";

  const closing = "Cu bucurie si recunostinta pentru momentele de conectare, multumim terapeutilor si voluntarilor asociatiei, parintilor, bunicilor si copiilor pentru tot ce au insemnat zilele petrecute impreuna.";

  const listItems = [
    {
      boldText: "Desensibilizarea senzoriala in mediul natural: ",
      normalText: sensoryDesc
    },
    {
      boldText: "Generalizarea abilitatilor prin terapie individuala: ",
      normalText: generalizationDesc
    },
    {
      boldText: "Magia socializarii prin grupuri de joaca: ",
      normalText: socializationDesc
    }
  ];

  // Carousel images array
  const carouselImages = [
    { id: 11, thumbnail: '/images/Postare post-tabara/11.jpeg', fullSize: '/images/Postare post-tabara/11.jpeg', alt: 'Retrospectiva taborei - imagine 11', modalSize: 'small' },
    { id: 19, thumbnail: '/images/Postare post-tabara/19.jpeg', fullSize: '/images/Postare post-tabara/19.jpeg', alt: 'Retrospectiva taborei - imagine 19', modalSize: 'large' },
    { id: 13, thumbnail: '/images/Postare post-tabara/13.jpeg', fullSize: '/images/Postare post-tabara/13.jpeg', alt: 'Retrospectiva taborei - imagine 13', modalSize: 'large' },
    { id: 9, thumbnail: '/images/Postare post-tabara/9.jpeg', fullSize: '/images/Postare post-tabara/9.jpeg', alt: 'Retrospectiva taborei - imagine 9', modalSize: 'small' },
    { id: 18, thumbnail: '/images/Postare post-tabara/18.jpeg', fullSize: '/images/Postare post-tabara/18.jpeg', alt: 'Retrospectiva taborei - imagine 18', modalSize: 'small' },
    { id: 1, thumbnail: '/images/Postare post-tabara/1.jpeg', fullSize: '/images/Postare post-tabara/1.jpeg', alt: 'Retrospectiva taborei - imagine 1', modalSize: 'small' },
    { id: 3, thumbnail: '/images/Postare post-tabara/3.jpeg', fullSize: '/images/Postare post-tabara/3.jpeg', alt: 'Retrospectiva taborei - imagine 3', modalSize: 'small' },
    { id: 17, thumbnail: '/images/Postare post-tabara/17.jpeg', fullSize: '/images/Postare post-tabara/17.jpeg', alt: 'Retrospectiva taborei - imagine 17', modalSize: 'small' },
    { id: 4, thumbnail: '/images/Postare post-tabara/4.jpeg', fullSize: '/images/Postare post-tabara/4.jpeg', alt: 'Retrospectiva taborei - imagine 4', modalSize: 'small' },
    { id: 5, thumbnail: '/images/Postare post-tabara/5.jpeg', fullSize: '/images/Postare post-tabara/5.jpeg', alt: 'Retrospectiva taborei - imagine 5', modalSize: 'small' },
    { id: 6, thumbnail: '/images/Postare post-tabara/6.jpeg', fullSize: '/images/Postare post-tabara/6.jpeg', alt: 'Retrospectiva taborei - imagine 6', modalSize: 'medium' },
     { id: 8, thumbnail: '/images/Postare post-tabara/8.jpeg', fullSize: '/images/Postare post-tabara/8.jpeg', alt: 'Retrospectiva taborei - imagine 8', modalSize: 'medium' },
    { id: 10, thumbnail: '/images/Postare post-tabara/10.jpeg', fullSize: '/images/Postare post-tabara/10.jpeg', alt: 'Retrospectiva taborei - imagine 10', modalSize: 'small' },
    { id: 14, thumbnail: '/images/Postare post-tabara/14.jpeg', fullSize: '/images/Postare post-tabara/14.jpeg', alt: 'Retrospectiva taborei - imagine 14', modalSize: 'large' },
    { id: 16, thumbnail: '/images/Postare post-tabara/16.jpeg', fullSize: '/images/Postare post-tabara/16.jpeg', alt: 'Retrospectiva taborei - imagine 16', modalSize: 'small' },
  ];

  return (
    <>
      <Helmet>
        <title>Am ajuns la mare…  Retrospectiva primei tabere pentru copiii cu autism</title>
        <meta
          name="description"
          content="Retrospectiva primei tabere terapeutice pentru copii cu autism. O experiență dedicată 12 copii cu tulburare de spectru autist și familiile lor în Eforie Nord, august-septembrie 2025."
        />
        <meta property="og:title" content="Am ajuns la mare… - Retrospectiva primei tabere pentru copiii cu autism" />
        <meta property="og:description" content="Retrospectiva primei tabere terapeutice pentru copii cu autism în Eforie Nord." />
        <meta property="og:image" content="%PUBLIC_URL%/images/tabara2.jpeg" />
        <meta property="og:url" content="https://www.psinapsis.ro/events/camp_retrospective" />
        <link rel="canonical" href="https://www.psinapsis.ro/events/camp_retrospective" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">
          
          <Title title="Am ajuns la mare…  Retrospectiva primei tabere pentru copiii cu autism" />
          
          <Details normalText={intro1} />
          <Details normalText={intro2} />
          
          <Details normalText={mainFocus} />

          {/* 3-item list */}
          <Container fluid>
            <Row>
              <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className="ps-1 ps-md-0 pe-2 pe-md-0">
                {listItems.map((item, i) => (
                  <div key={i} className="text-left fs-6 mb-3 mx-3 mx-md-4 objective-align-justify">
                    <span className="pe-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022" />
                      </svg>
                    </span>
                    <span className="fw-bold">{item.boldText}</span>
                    <span>{item.normalText}</span>
                  </div>
                ))}
              </Col>
            </Row>
          </Container>

          {/* Parent support section */}
          <Details normalText={parentSection1} />
          <Details normalText={parentSection2} />

          {/* Psychology quote */}
          <Container fluid>
            <div className="details text-justify fs-6 mb-3 mx-2">
              <span className="fst-italic">"{psyQuote}"</span>
              <div className="text-end mt-2">
                <span className="fw-bold">{psyAttribution}</span>
              </div>
            </div>
          </Container>

          {/* Closing paragraph */}
          <Details normalText={closing} />

          {/* Photo Carousel */}
          <div className="mt-5">
            <ReusableImageGallery images={carouselImages} />
          </div>

        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
